import React from 'react';
import SetupMFA from '../components/SetupMFA';
import action from '../actions/verifyTotpToken';

export const context = 'setupMFA';
export class Route extends React.PureComponent {
    render() {
        return <SetupMFA context={context} action={action} />;
    }
}

export default Route;
